import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  icon:string,
  textIcon:string,
  title:string,
  text:string,
  
  btnOneIcon:string,
  textBtnOne:string,
  linkAdress:string,

  textExtra:string,

  infoBoxIcon:string,
  infoBoxSpan:string,
  infoBoxNumber:string,
}
@Component({
  selector: 'app-model-modal-one-button',
  templateUrl: './model-modal-one-button.component.html',
  styleUrls: ['./model-modal-one-button.component.scss']
})
export class ModelModalOneButtonComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModelModalOneButtonComponent>,  @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}
